<template>
  <v-popover offset="4"
             open-group="comment-popover"
             :open="edit_mode"
             trigger="manual"
             @hide="edit_mode = false"
             popoverClass="comment-popover">
    <IconChat v-tooltip="comment"
              @click.native.stop="start"
              class="comment-icon group-hover:opacity-100"
              :class="{'has-comment': !!comment}"/>
    <template slot="popover">
      <div class="grid grid-cols-2 col-gap-4 row-gap-4">
        <div class="col-span-2">
          <BaseTextarea v-model="new_comment" :label="$t('commentLabel')" size="sm" ref="input"/>
        </div>
        <BaseButton theme="red" size="sm"
                    :disabled="isSubmitted"
                    @click="save" v-close-popover>
          {{ $t('save') }}
        </BaseButton>
        <BaseButton theme="default" size="sm"
                    @click="cancel" v-close-popover>
          {{ $t('cancel') }}
        </BaseButton>
      </div>
    </template>
  </v-popover>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import IconChat from "@/components/icons/IconChat";
import BaseButton from "@/components/UI/BaseButton";
import BaseTextarea from "@/components/UI/BaseTextarea";

export default {
  name: "BudgetItemCommentEdit",
  components: {BaseTextarea, BaseButton, IconChat},
  props: {
    comment: {
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isSubmitted: false,
      edit_mode: false,
      new_comment: ''
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    ...mapGetters('space/budgets', ['budgetTypeHelper']),
  },
  methods: {
    ...mapActions('space/budgets', ['updateBudget']),
    ...mapMutations('space/budgets', ['setNewComment']),
    start() {
      if (this.currentUserIsWatcher) return;
      this.edit_mode = true;
      this.new_comment = this.comment;
      setTimeout(() => {
        this.$refs.input.$refs.textarea.focus()
      }, 200)
    },
    cancel() {
      this.edit_mode = false;
      this.new_comment = '';
    },
    save() {
      let budget_type = this.budgetTypeHelper(this.type);
      const data = {
        id: this.id,
        comment: this.new_comment,
        budget_type
      }

      this.isSubmitted = true;
      this.updateBudget(data).then(res => {
        if (res.body.success) {
          this.setNewComment(data)
          this.$toasted.success('Комментарий успешно добавлен')
          this.edit_mode = false;
          this.new_comment = '';
        } else {
          this.$toasted.error('Произошла ошибка')
        }
        this.isSubmitted = false;
      });
    }
  },
  i18n: {
    messages: {
      en: {
        commentLabel: 'Your comment',
        save: 'Save',
        cancel: 'Cancel'
      },
      ru: {
        commentLabel: 'Ваш комментарий',
        save: 'Сохранить',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.comment-icon {
  @apply text-icon ml-4 opacity-0 mt-2 cursor-pointer;
  transition: all .2s;

  &:hover {
    @apply text-icon-hover;
  }

  &.has-comment {
    @apply opacity-100 text-icon-hover;
  }

  &:focus {
    @apply outline-none;
  }
}

.comment-popover.popover {
  .popover-inner {
    @apply p-4 pt-6;
  }

  &:focus {
    @apply outline-none;
  }
}
</style>